export const usersRoutes = {
  list: "",
  details: ":id",
  new: "new",
  edit: ":id/edit",
  editSelf: "self",
  bulkUpload: "import",
} as const;

export type UsersRouteParams = {
  list: {
    tab?: string;
    statuses?: string;
    companyId?: string;
    sortBy?: string;
    sortDescending?: string;
    search?: string;
  };
};
